import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../../components/footer/footer.component';
import { CommonHeaderComponent } from '../../../../components/common-header/common-header.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'virginairline',
  standalone: true,
  imports: [FooterComponent, CommonHeaderComponent, CommonModule],
  templateUrl: './virginairline.component.html',
  styleUrl: './virginairline.component.scss',
})
export class VirginairlineComponent {
  constructor(
    private sanitizer: DomSanitizer,
    private titleService: Title,
    private metaService: Meta,
  ) {}
  pageContent: SafeHtml = '';
  pageTitleImg: string = '';
  pageHead: string = 'Virgin Airline';

  ngOnInit() {
    this.titleService.setTitle('Virgin Airline');
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Virgin Airline',
    });
    this.pageTitleImg = 'assets/images/w2c/page-header/travel-in.jpg';
  }
}
